import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";

export function useStableHandlers<T extends Record<string, (...args: any[]) => any>>(handlers: T): T {
  const ref = useRef(handlers);
  ref.current = handlers;

  return useMemo(() => {
    const stable = {} as T;
    for (const key in handlers) {
      stable[key] = ((...args: any[]) => ref.current[key](...args)) as T[typeof key];
    }
    return stable;
  }, []); // 최초 1회만 생성, 이후 항상 같은 참조
}
